// extracted by mini-css-extract-plugin
export default {"like":"_3UUUC","not-clickable":"_3zK-i","notClickable":"_3zK-i","likebutton":"vnWkv","likes":"m_GUB"};